function StatisticTabBody({ Component = 'div', ...restProps }) {
  return <Component {...restProps} />
}

export default StatisticTabBody
